import { motion } from 'framer-motion';

export const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 24, className = '', amount = 0.25 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount }}
      transition={{ duration: 0.6, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLines({ lines, className = '', lineClassName = '', delay = 0.15 }) {
  return (
    <motion.div
      className={className}
      initial="hidden"
      animate="show"
      variants={{ hidden: {}, show: { transition: { staggerChildren: 0.12, delayChildren: delay } } }}
    >
      {lines.map((line, i) => (
        <div key={i} className="overflow-hidden">
          <motion.div
            className={lineClassName}
            variants={{ hidden: { y: '110%' }, show: { y: '0%' } }}
            transition={{ duration: 0.9, ease: EASE }}
          >
            {line}
          </motion.div>
        </div>
      ))}
    </motion.div>
  );
}

export function Marquee({ items, dark = true }) {
  const row = [...items, ...items];
  return (
    <div
      data-testid="editorial-marquee"
      className={`overflow-hidden border-y ${dark ? 'border-gold/15 bg-navy-800' : 'border-navy/10 bg-white'} py-4`}
    >
      <div className="flex w-max animate-marquee items-center gap-10 whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className={`font-serif italic text-lg sm:text-xl ${dark ? 'text-[#00BFFF]' : 'text-navy/70'}`}>{item}</span>
            <span className={`font-mono text-xs ${dark ? 'text-gold/40' : 'text-electric/50'}`}>◆</span>
          </span>
        ))}
      </div>
    </div>
  );
}
